import CONST from './Constant';
import {axiosPublic} from "../../../../Setup/Axios/SetupAxios";
import { handleAsyncAction } from '../../../../Setup';
import axiosPrivate from "../../../../Setup/Axios/SetupAxios";
import {fetchAppConfig} from "../../App";


/****************************************************
 * Register
 ****************************************************/
export const handleRegisterSuccess = (payload) => ({
    type: CONST.REGISTER_USER_SUCCESS,
    payload: payload
});

export const handleRegisterFailed = (payload) => ({
    type: CONST.REGISTER_USER_FAILED,
    payload: payload
});

export const handleRegister = ({dispatch, data}) => {

    return handleAsyncAction(
        dispatch,
        () => axiosPublic.post('core/register', data),
        [handleRegisterSuccess],
        [handleRegisterFailed]
    );
};


/****************************************************
 * Verify Email
 ****************************************************/
export const verifyEmailSuccess = (payload) => ({
    type: CONST.VERIFY_EMAIL_SUCCESS,
    payload: payload
});

export const verifyEmailFailed = (payload) => ({
    type: CONST.VERIFY_EMAIL_FAILED,
    payload: payload
});

export const verifyEmail = async ({dispatch, data}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPublic.post('core/auth/verify-email', data),
        [verifyEmailSuccess],
        [verifyEmailFailed]
    );
}

/****************************************************
 * Verify OTP
 ****************************************************/
export const verifyOtpSuccess = (payload) => ({
    type: CONST.VERIFY_OTP_SUCCESS,
    payload: payload
});

export const verifyOtpFailed = (payload) => ({
    type: CONST.VERIFY_OTP_FAILED,
    payload: payload
});

export const verifyOtp = async ({dispatch, data}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPublic.post('core/auth/verify-otp', data),
        [verifyOtpSuccess],
        [verifyOtpFailed]
    );
}

/****************************************************
 * Resend OTP
 ****************************************************/
export const resendOtpSuccess = (payload) => ({
    type: CONST.RESEND_OTP_SUCCESS,
    payload: payload
});

export const resendOtpFailed = (payload) => ({
    type: CONST.RESEND_OTP_FAILED,
    payload: payload
});

export const resendOtp = async ({dispatch, data}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPublic.post('core/auth/resend-otp', data),
        [resendOtpSuccess],
        [resendOtpFailed]
    );
}

/****************************************************
* Forgot Password
* ****************************************************/
export const forgotPasswordSuccess = (payload) => ({
    type: CONST.FORGOT_PASSWORD_SUCCESS,
    payload: payload
});

export const forgotPasswordFailed = (payload) => ({
    type: CONST.FORGOT_PASSWORD_FAILED,
    payload: payload
});

export const forgotPassword = async ({dispatch, data}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPublic.post('core/auth/forgot-password', data),
        [forgotPasswordSuccess],
        [forgotPasswordFailed]
    );
}

/****************************************************
 * SET PASSWORD
 ****************************************************/
export const setPasswordSuccess = (payload) => ({
    type: CONST.SET_PASSWORD_SUCCESS,
    payload: payload
});

export const setPasswordFailed = (payload) => ({
    type: CONST.SET_PASSWORD_FAILED,
    payload: payload
});

export const setPassword = async ({dispatch, data}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.post('core/auth/set-password', data),
        [setPasswordSuccess],
        [setPasswordFailed]
    );
}

/****************************************************
 * SETUP PASSWORD (with token)
 ****************************************************/
export const setupPasswordSuccess = (payload) => ({
    type: CONST.SETUP_PASSWORD_SUCCESS,
    payload: payload
});

export const setupPasswordFailed = (payload) => ({
    type: CONST.SETUP_PASSWORD_FAILED,
    payload: payload
});

export const setupPassword = async ({dispatch, data}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPublic.post('core/auth/setup-password', data),
        [setupPasswordSuccess],
        [setupPasswordFailed]
    );
}


/****************************************************
 * Login
 ****************************************************/
export const handleLoginSuccess = (payload) => ({
    type: CONST.LOGIN_SUCCESS,
    payload: payload
});

export const handleLoginFailed = (payload) => ({
    type: CONST.LOGIN_FAILED,
    payload: payload
});

export const handleLogin = async ({dispatch, data}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPublic.post('core/auth/login', data),
        [handleLoginSuccess, () => fetchAppConfig({dispatch})],
        [handleLoginFailed]
    );
}

/****************************************************
 * Logout
 ****************************************************/
export const handleLogoutSuccess = () => ({
    type: CONST.LOGOUT_SUCCESS,
});

export const handleLogoutFailed = (payload) => ({
    type: CONST.LOGOUT_FAILED,
    payload,
});

export const handleLogout = async (dispatch) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.post('core/auth/logout'),
        [handleLogoutSuccess],
        [handleLogoutFailed]
    );
};

/****************************************************
 FETCH USER PERMISSIONS
****************************************************/
export const fetchRefreshUserSuccess = (payload) => ({
    type: CONST.REFRESH_USER_SUCCESS,
    payload: payload
});
export const fetchRefreshUserFailed = (payload) => ({
    type: CONST.REFRESH_USER_FAILED,
    payload: payload
});
export const refreshUser = async ({dispatch}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.post('core/auth/refresh-user'),
        [fetchRefreshUserSuccess, () => fetchAppConfig({ dispatch })],
        [fetchRefreshUserFailed]
    );
}

/****************************************************
 * Refresh Token
 ****************************************************/
export const refreshTokenSuccess = (payload) => ({
    type: CONST.REFRESH_TOKEN_LOADING,
    payload: payload
});

export const refreshTokenFailed = (payload) => ({
    type: CONST.REFRESH_TOKEN_FAILED,
    payload: payload
});

export const refreshToken = (payload) => ({
    type: CONST.REFRESH_TOKEN_LOADING,
    payload: payload
});

/****************************************************
 * Mark Notification Read
 ****************************************************/
export const markAllReadNotificationSuccess = (payload) => ({
    type: CONST.MARK_NOTIFICATION_READ_SUCCESS,
    payload: payload
});

export const markAllReadNotificationFailed = (payload) => ({
    type: CONST.MARK_NOTIFICATION_READ_FAILED,
    payload: payload
});

export const markAllReadNotification = async ({dispatch}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.patch('core/notification/all/read'),
        [markAllReadNotificationSuccess],
        [markAllReadNotificationFailed]
    );
};

/****************************************************
 * Update Profile
 ****************************************************/
export const updateProfileSuccess = (payload) => ({
    type: CONST.UPDATE_PROFILE_SUCCESS,
    payload: payload
});

export const updateProfileFailed = (payload) => ({
    type: CONST.UPDATE_PROFILE_FAILED,
    payload: payload
});
